<template>
    <div id="app">
        <el-container style="height: 100vh;" v-if="$route.path !== '/login'">
            <!-- 左侧侧边栏：结合移动端隐藏/展开逻辑 -->
            <el-aside
                    :width="isCollapse ? '64px' : '220px'"
                    style="background:#fff;border-right:1px solid #eee;transition: width 0.3s ease;z-index:100;"
                    :class="{ 'mobile-aside-hide': isMobile && !showMobileMenu, 'mobile-aside-show': isMobile && showMobileMenu }"
            >
                <!-- 侧边栏标题 -->
                <div
                        style="height:60px; display:flex; align-items:center; justify-content:center; border-bottom:1px solid #eee; padding:0 10px;">
                    <div
                            style="display:flex; align-items:center; gap:8px; white-space:nowrap; transition: opacity 0.3s ease;"
                            :style="{ opacity: isCollapse ? 0 : 1, width: isCollapse ? 0 : 'auto', overflow: 'hidden' }"
                    >
                        <img src="@/assets/images/logo.png" alt="logo"
                             style="height:32px; width:32px; object-fit:contain;">
                        <span style="font-size:16px; font-weight:bold;">客服系统</span>
                    </div>
                    <img
                            v-show="isCollapse"
                            src="@/assets/images/logo.png"
                            alt="logo"
                            style="height:32px; width:32px; object-fit:contain; position:absolute;"
                    >
                </div>

                <!-- 侧边栏菜单 -->
                <el-menu
                        :key="menuRefreshKey"
                        :default-active="$route.path"
                        background-color="#fff"
                        text-color="#333"
                        active-text-color="#333"
                        router
                        :collapse="isCollapse"
                        :collapse-transition="false"
                        :open-names="openMenus"
                        @open="handleMenuOpen"
                >
                    <!-- 遍历接口返回的顶层菜单 -->
                    <template v-for="menu in menuList">
                        <!-- 无子菜单：普通菜单项 -->
                        <el-menu-item
                                v-if="!menu.children || menu.children.length === 0"
                                :key="menu.id"
                                :index="menu.path || ''"
                        >
                            <i :class="menu.icon || 'el-icon-menu'"></i>
                            <span slot="title">{{ menu.name }}</span>
                        </el-menu-item>

                        <!-- 有子菜单：下拉子菜单 -->
                        <el-submenu
                                v-else
                                :key="menu.id"
                                :index="String(menu.id)"
                        >
                            <template slot="title">
                                <i :class="menu.icon || 'el-icon-menu'"></i>
                                <span>{{ menu.name }}</span>
                            </template>
                            <!-- 递归渲染子菜单 -->
                            <template v-for="child in menu.children">
                                <el-menu-item
                                        :key="child.id"
                                        :index="child.path || ''"
                                >
                                    <i :class="child.icon || 'el-icon-menu'"></i>
                                    <span slot="title">{{ child.name }}</span>
                                </el-menu-item>
                            </template>
                        </el-submenu>
                    </template>
                </el-menu>
            </el-aside>

            <el-container style="width: 100%;" :class="{ 'mobile-main-full': isMobile && !showMobileMenu }">
                <!-- 顶部Header：重构移动端布局 -->
                <el-header
                        style="background:#fff;border-bottom:1px solid #e6e6e6;display:flex;align-items:center;justify-content:space-between;padding:0 16px;position:relative;">
                    <!-- 左侧区域：折叠按钮（PC）/ 移动端菜单按钮 -->
                    <div class="header-left">
                        <!-- PC端折叠按钮 -->
                        <i
                                :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
                                @click="toggleCollapse"
                                v-show="!isMobile"
                                style="cursor:pointer;"
                        ></i>
                        <!-- 移动端菜单按钮 -->
                        <i
                                class="el-icon-menu mobile-menu-icon"
                                @click="toggleMobileMenu"
                                v-show="isMobile"
                                style="font-size:20px;cursor:pointer;"
                        ></i>
                    </div>

                    <!-- 右侧区域：用户信息 -->
                    <div class="header-right">
                        <el-dropdown trigger="hover" :hide-on-click="false">
                            <div style="display:flex;align-items:center;cursor:pointer;">
                                <el-avatar size="medium" class="custom-logo-avatar">
                                    <img :src="require('@/assets/images/logo.png')" class="logo-img" />
                                </el-avatar>
                                <span style="margin-left:8px;">
                                    {{ userInfo ? userInfo.username : '商户管理员' }} <i
                                        class="el-icon-arrow-down"></i>
                                </span>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="openPersonalCenter">个人中心</el-dropdown-item>
                                <el-dropdown-item @click.native="openPwdDialog">修改密码</el-dropdown-item>
                                <el-dropdown-item divided @click.native="handleLogout">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </el-header>

                <!-- 标签栏 -->
                <div
                        ref="tabsContainer"
                        style="background:#fff; padding:8px 16px; border-bottom:1px solid #e6e6e6; display:flex; align-items:center;">

                    <!-- 标签列表 -->
                    <div ref="tabsList" style="display:flex; gap:6px; flex-wrap:wrap; flex:1;">
                        <div
                                v-for="(item,index) in visibleTabs"
                                :key="item.path"
                                style="display:flex; align-items:center;"
                        >
                            <!-- 标签按钮 -->
                            <el-radio-group
                                    v-model="currentPath"
                                    size="small"
                                    @change="handleTabChange"
                                    style="margin:0;"
                            >
                                <el-radio-button :label="item.path" class="tab-btn">
                                    {{ item.title }}
                                    <i class="el-icon-close" v-if="item.path !== '/dashboard'"
                                       @click="closeTab(item.path)"></i>
                                </el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>

                    <!-- 右侧下拉按钮：关闭全部 / 当前 / 其他 -->
                    <el-dropdown size="mini" trigger="click">
                        <el-button size="mini" icon="el-icon-arrow-down"></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="closeCurrentTab">关闭当前</el-dropdown-item>
                            <el-dropdown-item @click.native="closeOtherTabs">关闭其他</el-dropdown-item>
                            <el-dropdown-item @click.native="closeAllTabs">关闭全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>

                <!-- 主内容区 -->
                <el-main
                        style="background:#f5f7fa;padding:16px;overflow:auto;min-height: calc(100vh - 112px);width:100%;">
                    <router-view/>
                </el-main>
            </el-container>
        </el-container>

        <router-view v-if="$route.path === '/login'"
                     style="min-height:100vh;display:flex;align-items:center;justify-content:center;"/>

        <div class="login-footer">
            <div class="footer-content">
                <p>易联云 - Copyright 2026 Elind Powered by <a href="https://www.yilianyun.net">www.yilianyun.net</a>
                </p>
                <p><a href="https://beian.miit.gov.cn/">蜀ICP备14004509号</a></p>
            </div>
        </div>
        <!-- 修改密码弹窗 -->
        <el-dialog
                title="修改密码"
                :visible.sync="pwdDialogVisible"
                width="500px"
                :close-on-click-modal="false"
                :before-close="handleDialogClose"
                :width="isMobile ? '90%' : '500px'"
        >
            <el-form
                    ref="pwdFormRef"
                    :model="pwdForm"
                    :rules="pwdRules"
                    label-width="100px"
                    style="margin-top:10px;"
            >
                <el-form-item label="原始密码" prop="password">
                    <el-input
                            v-model="pwdForm.password"
                            type="password"
                            placeholder="请输入原始密码"
                            show-password
                    />
                </el-form-item>
                <el-form-item label="新密码" prop="new_password">
                    <el-input
                            v-model="pwdForm.new_password"
                            type="password"
                            placeholder="请输入新密码（8-20位，含字母和数字）"
                            show-password
                    />
                </el-form-item>
                <el-form-item label="确认新密码" prop="confirmPwd">
                    <el-input
                            v-model="pwdForm.confirmPwd"
                            type="password"
                            placeholder="请再次输入新密码"
                            show-password
                    />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pwdDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitPwdChange" :loading="pwdSubmitting">确认修改</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import store from '@/store'
import {changePassword, logout} from '@/api'

export default {
    name: 'App',
    computed: {
        ...mapState('app', ['userInfo', 'menuList', 'refreshFlag']),
        menuRefreshKey() {
            return this.refreshFlag
        },
        visibleTabs() {
            return this.calcVisibleTabs()
        }
    },
    data() {
        // 验证新密码与确认密码一致
        const validateConfirmPwd = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请再次输入新密码'))
            }
            if (value !== this.pwdForm.new_password) {
                callback(new Error('两次输入的新密码不一致'))
            } else {
                callback()
            }
        }

        return {
            isCollapse: false,
            currentPath: this.$route.path,
            visitedTabs: [
                {path: '/customer-search', title: '查找客户'}
            ],
            // 修改密码弹窗相关
            pwdDialogVisible: false,
            pwdSubmitting: false,
            pwdForm: {
                password: '',
                new_password: '',
                confirmPwd: ''
            },
            // 密码校验规则
            pwdRules: {
                password: [
                    {required: true, message: '请输入原始密码', trigger: 'blur'}
                ],
                new_password: [
                    {required: true, message: '请输入新密码', trigger: 'blur'},
                    {min: 8, max: 20, message: '新密码长度需在8-20位之间', trigger: 'blur'},
                    {pattern: /^(?=.*[a-zA-Z])(?=.*\d).{8,20}$/, message: '新密码需包含字母和数字', trigger: 'blur'}
                ],
                confirmPwd: [
                    {required: true, message: '请再次输入新密码', trigger: 'blur'},
                    {validator: validateConfirmPwd, trigger: 'blur'}
                ]
            },
            // 新增：移动端相关状态
            isMobile: false,        // 是否为手机端
            showMobileMenu: false,   // 移动端是否显示侧边栏
            openMenus: [],           // 新增：控制展开的子菜单列表（核心）
            tabWidth: 0
        }
    },
    watch: {
        $route(to) {
            this.currentPath = to.meta.parentTab || to.path
            this.addTabByPath(this.currentPath)
            // 移动端切换路由后自动隐藏侧边栏
            if (this.isMobile) {
                this.showMobileMenu = false
            }
            this.$nextTick(() => {
                this.calcVisibleTabs()
            })
        },
        visitedTabs: {
            handler() {
                this.$nextTick(() => {
                    this.calcVisibleTabs()
                })
            },
            deep: true
        }
    },
    mounted() {
        console.log(localStorage.getItem('isLoggedIn'))
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        this.$nextTick(() => {
            this.calcTabWidth()
            this.calcVisibleTabs()
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        toggleCollapse() {
            this.isCollapse = !this.isCollapse
        },
        handleMenuOpen(menuIndex) {
            // 重置展开列表，只保留当前点击的子菜单
            this.openMenus = [menuIndex]
        },
        // 切换标签
        handleTabChange(path) {
            if (path === this.currentParentTab) return
            const defaultSubPath = {
                '/customer': '/customer',
                '/order': '/order',
                '/system-setting': '/system-setting',
            }
            this.$router.push(defaultSubPath[path] || path).catch(() => {
            })
        },
        // 根据路由添加标签
        addTabByPath(path) {
            let exist = this.visitedTabs.some(t => t.path === path)
            if (exist) return
            const targetMenu = this.findMenuByPath(this.menuList, path)
            if (targetMenu) {
                this.visitedTabs.push({
                    path: targetMenu.path,
                    title: targetMenu.name,
                    icon: targetMenu.icon,
                })
            }
        },
        calcTabWidth() {
            const firstTab = this.$refs.tabsList?.querySelector('.tab-btn')
            if (firstTab) {
                this.tabWidth = firstTab.offsetWidth + 6 // 6是标签间距
            }
        },
        calcVisibleTabs() {
            if (!this.$refs.tabsContainer || !this.$refs.tabsList || this.visitedTabs.length <= 1) {
                return this.visitedTabs
            }

            // 获取容器宽度（减去右侧下拉按钮宽度）
            const containerWidth = this.$refs.tabsContainer.offsetWidth - 60 // 60是下拉按钮宽度
            // 重新计算标签宽度（防止窗口变化）
            this.calcTabWidth()

            if (this.tabWidth === 0) return this.visitedTabs

            // 最大可显示标签数量
            const maxTabCount = Math.floor(containerWidth / this.tabWidth)
            const totalTabs = this.visitedTabs.length

            // 如果未超出，返回所有标签
            if (totalTabs <= maxTabCount) {
                return this.visitedTabs
            }

            // 超出时：保留最后maxTabCount个标签（强制保留仪表盘）
            let visibleTabs = [...this.visitedTabs]
            const dashboardIndex = visibleTabs.findIndex(t => t.path === '/customer-search')

            // 删除前面的标签（保留仪表盘和最后几个）
            while (visibleTabs.length > maxTabCount) {
                // 找到第一个非仪表盘的标签并删除
                const deleteIndex = visibleTabs.findIndex(t => t.path !== '/customer-search' && t.path !== this.currentPath)
                if (deleteIndex > -1) {
                    visibleTabs.splice(deleteIndex, 1)
                    // 同步更新原始visitedTabs
                    this.visitedTabs = [...visibleTabs]
                } else {
                    // 只剩仪表盘和当前标签时停止
                    break
                }
            }

            return visibleTabs
        },

        findMenuByPath(menuArr, targetPath) {
            for (const menu of menuArr) {
                // 当前菜单匹配
                if (menu.path === targetPath) {
                    return menu
                }
                // 存在子菜单，递归查找子级
                if (menu.children && menu.children.length > 0) {
                    const childResult = this.findMenuByPath(menu.children, targetPath)
                    if (childResult) return childResult
                }
            }
            // 全部遍历完未找到
            return null
        },
        // 关闭单个标签 → 关闭后跳上一个
        closeTab(path) {
            if (path === '/dashboard') return;

            const index = this.visitedTabs.findIndex(t => t.path === path);
            if (index === -1) return;

            let prevTab = null;
            if (index > 0) {
                prevTab = this.visitedTabs[index - 1];
            } else {
                prevTab = this.visitedTabs[1];
            }

            this.visitedTabs.splice(index, 1);

            if (path === this.currentPath) {
                this.currentPath = prevTab.path;
                const defaultSubPath = {
                    '/customer': '/customer',
                    '/order': '/order',
                    '/system-setting': '/system-setting',
                }
                this.$router.push(defaultSubPath[prevTab.path] || prevTab.path).catch(() => {
                });
            }
        },
        // 关闭当前
        closeCurrentTab() {
            this.closeTab(this.currentPath)
        },
        // 关闭其他
        closeOtherTabs() {
            this.visitedTabs = this.visitedTabs.filter(t =>
                t.path === '/dashboard' || t.path === this.currentPath
            )
        },
        // 关闭全部
        closeAllTabs() {
            this.visitedTabs = [{path: '/customer-search', title: '查找客户'}]
            this.currentPath = '/customer-search'
            this.$router.push('/customer-search').catch(() => {
            })
        },
        async handleLogout() {
            try {
                await logout()
                store.commit('app/LOGOUT_ALL')
                this.visitedTabs = [{path: '/customer-search', title: '查找客户'}]
                this.$router.replace('/login')
                this.$message.success('退出成功')
            } catch (e) {
                this.$message.error('退出失败')
            }
        },
        // 新增：处理窗口大小变化（核心自适应逻辑）
        handleResize() {
            const isMobile = window.innerWidth < 768
            this.isMobile = isMobile

            // 手机端默认折叠侧边栏 + 隐藏
            if (isMobile) {
                this.isCollapse = true
                this.showMobileMenu = false
            } else {
                // 非手机端恢复默认状态
                this.isCollapse = false
                this.showMobileMenu = true
            }
            this.$nextTick(() => {
                this.calcVisibleTabs()
            })
        },
        // 新增：移动端切换菜单显示/隐藏
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu
        },
        openPersonalCenter() {
            this.$router.push('/personal-center').catch(() => {
            })
        },
        // 打开修改密码弹窗
        openPwdDialog() {
            this.pwdDialogVisible = true
            this.$nextTick(() => {
                this.$refs.pwdFormRef.resetFields()
                this.pwdForm = {
                    password: '',
                    new_password: '',
                    confirmPwd: ''
                }
            })
        },
        // 关闭弹窗时重置状态
        handleDialogClose() {
            this.pwdSubmitting = false
            this.$refs.pwdFormRef.resetFields()
            this.pwdDialogVisible = false
        },
        // 提交密码修改
        async submitPwdChange() {
            try {
                await this.$refs.pwdFormRef.validate()
                this.pwdSubmitting = true

                changePassword(this.pwdForm).then((res) => {
                    if (res.code === 0) {
                        this.$message.success('密码修改成功，请重新登录')
                        this.pwdDialogVisible = false
                        this.handleLogout()
                    }
                })
            } catch (error) {
                this.$message.error(error.message || '密码修改失败，请重试')
            } finally {
                this.pwdSubmitting = false
            }
        }
    }
}
</script>

<style>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
    width: 100%;
    min-height: 100vh;
}

#app .tabs-list {
    white-space: nowrap;
}

.iconfont {
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    vertical-align: middle;
}

.tab-btn:hover {
    color: #1864ff;
}

.el-menu-item:hover {
    background: #f0f7ff !important;
    color: #409eff !important;
}

.el-menu-item.is-active {
    background: #e6f1ff !important;
    color: #409eff !important;
    font-weight: 500;
}

.el-menu-item.is-active i {
    color: #409eff !important;
}

.el-menu-item i {
    font-size: 18px;
    color: #8892a0;
}

.el-submenu__title:hover {
    background: #f0f7ff !important;
    color: #409eff !important;
}

.el-submenu__title i {
    font-size: 18px;
    color: #8892a0;
}

/* 子菜单容器底色区分 */
.el-submenu .el-menu {
    background: #fbfdff !important;
}

/* 折叠时文字完全平滑消失 */
.el-menu--collapse .el-menu-item span,
.el-menu--collapse .el-submenu__title span {
    opacity: 0;
}

.el-radio-button__inner {
    border-radius: 4px !important;
    padding: 0 14px;
}

.el-card__body {
    padding: 15px 20px 0 !important;
}

.el-card {
    border-radius: 10px !important;
}

.app-footer {
    background-color: #f8f9fa;
    border-top: 1px solid #e6e6e6;
    padding: 16px 0;
    margin-top: auto;
    width: 100%;
}

::v-deep .custom-logo-avatar {
    line-height: normal !important;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.logo-img {
    width: 100%;
    height: auto; /* 重点！高度自动，不再100%拉伸 */
    object-fit: contain;
}

.login-footer {
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: transparent;
    padding: 16px 0;
}

.footer-content {
    text-align: center;
}

.footer-content p {
    color: #666;
    font-size: 12px;
    line-height: 1.6;
    margin: 0;
}

.footer-content a {
    text-decoration: none;
    color: inherit;
}

a:hover, a:active, a:focus {
    text-decoration: none;
    color: #1864ff;
}

.footer-content p:first-child {
    margin-bottom: 4px;
}

/* Header布局样式 */
.header-left {
    display: flex;
    align-items: center;
}

.header-right {
    display: flex;
    align-items: center;
}

/* 移动端侧边栏样式 */
.mobile-aside-hide {
    position: fixed;
    left: -220px;
    top: 0;
    height: 100vh;
    transition: left 0.3s ease;
}

.mobile-aside-show {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    transition: left 0.3s ease;
}

.mobile-main-full {
    margin-left: 0 !important;
    width: 100% !important;
}

/* 响应式适配 */
@media (max-width: 768px) {
    .el-header {
        padding: 0 16px !important;
        height: 60px !important;
    }

    .el-main {
        padding: 8px;
        min-height: calc(100vh - 112px) !important;
    }

    /* 移动端标签栏优化 */
    .el-radio-button__inner {
        padding: 0 8px;
        font-size: 12px;
    }

    /* 移动端用户信息优化 */
    .header-right .el-avatar {
        width: 32px;
        height: 32px;
    }

    .header-right span {
        font-size: 14px;
        margin-left: 4px;
    }

    /* 移动端下拉菜单适配 */
    .el-dropdown-menu {
        min-width: 120px;
    }
}

@media (max-width: 480px) {
    .footer-content p {
        font-size: 11px;
    }

    /* 移动端表单标签宽度适配 */
    .el-form-item__label {
        font-size: 12px;
    }

    .el-input {
        font-size: 12px;
    }

    /* 移动端用户信息进一步优化 */
    .header-right span {
        font-size: 12px;
        margin-left: 2px;
    }

    .mobile-menu-icon {
        font-size: 18px !important;
    }
}

/* 非移动端样式 */
@media (min-width: 768px) {
    .mobile-aside-hide, .mobile-aside-show {
        position: static !important;
        left: auto !important;
    }

    .mobile-main-full {
        margin-left: auto !important;
    }
}
</style>